module.exports = __webpack_public_path__ + "media/images/clutch_kits/SACHS-2cbf32d94584709e2a5879293bb890bc.jpg";